import React from "react";

type Props = {
	heading: string;
	duration: string;
	role: string;
};

class Item extends React.Component<Props, {}> {
	render() {
		return (
			<div className="row">
				<div className="col Item">
					<h4>
						<span>
							{this.props.heading}
						</span>
					</h4>
					<span>
						<b>{this.props.role}</b>
					</span>
					<p>
						<i>{this.props.duration}</i>
					</p>
					<p>{this.props.children}</p>
				</div>
			</div>
		);
	}
}

export default Item;
